import { render, staticRenderFns } from "./unitMaterialConsum.vue?vue&type=template&id=05695af8&scoped=true"
import script from "./unitMaterialConsum.vue?vue&type=script&lang=js"
export * from "./unitMaterialConsum.vue?vue&type=script&lang=js"
import style0 from "./unitMaterialConsum.vue?vue&type=style&index=0&id=05695af8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05695af8",
  null
  
)

export default component.exports